import apiClient from './apiClient';

const API_URL = '/estados';

// Obtener todos los estados
export const getEstados = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Obtener un estado específico por ID
export const getEstadoPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};
